const angular = require('angular');
var pdfjsImport = require('../imports/pdfjs');

const app = angular.module('learn-directives');
/**
 * Defines the media viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('pdfView', ['Analyze', function (Analyze) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      link: '=',
      fileId: '=?',
      tracking: '=?',
      completionPercent: '=?',
      onComplete: '&?',
      preview: '<'
    },
    template: require('../../templates/directives/pdfjs-view.html'),
    controller: ['$scope', '$sce', '$timeout', '$window', function ($scope, $sce, $timeout, $window) {
      var self = this;
      var pdfDoc;
      
      self.isRetina = function(){
        var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
                (min--moz-device-pixel-ratio: 1.5),\
                (-o-min-device-pixel-ratio: 3/2),\
                (min-resolution: 1.5dppx)";
        if ($window.devicePixelRatio > 1)
            return true;
        if ($window.matchMedia && $window.matchMedia(mediaQuery).matches)
            return true;
        return false;
      };
            
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.upscaleBase = 2;
      } else if (self.isRetina() === false) {
        self.upscaleBase = 1;
      } else {
        self.upscaleBase = 2;
      };

      var CustomStyle = function CustomStyleClosure() {
        var prefixes = ['ms', 'Moz', 'Webkit', 'O'];
        var _cache = Object.create(null);
        function CustomStyle() {}
        CustomStyle.getProp = function get(propName, element) {
          if (arguments.length === 1 && typeof _cache[propName] === 'string') {
            return _cache[propName];
          }
          element = element || document.documentElement;
          var style = element.style,
              prefixed,
              uPropName;
          if (typeof style[propName] === 'string') {
            return _cache[propName] = propName;
          }
          uPropName = propName.charAt(0).toUpperCase() + propName.slice(1);
          for (var i = 0, l = prefixes.length; i < l; i++) {
            prefixed = prefixes[i] + uPropName;
            if (typeof style[prefixed] === 'string') {
              return _cache[propName] = prefixed;
            }
          }
          return _cache[propName] = 'undefined';
        };
        CustomStyle.setProp = function set(propName, element, str) {
          var prop = this.getProp(propName);
          if (prop !== 'undefined') {
            element.style[prop] = str;
          }
        };
        return CustomStyle;
      }();

      var checkReturn = function() {
        if (!$scope.fileId) {
          return;
        }
        self.pdf.returning = true;
        Analyze.userPdfs({subresource: $scope.fileId}).$promise
        .then(function(item) {
          if (!item || !item.last_position) {
            self.pdf.returning = false;
            $scope.tracking.setInitialPosition(0);
            return;
          }
          $scope.tracking.setInitialPosition(item.last_position);

          if (self.pdf.viewSetting) {
            self.pdf.returnTo = item.last_position;
            return;
          }

          self.navigation.pageNum = Math.round(item.last_position / 100 * self.pdf.totalPages);
        });
      };

      var record = function (page) {
        if (!$scope.fileId) {
          return;
        }
        var percent = page / self.pdf.totalPages * 100;
        Analyze.record(
          {resource: 'user-pdfs'},
          {content: $scope.fileId, position: percent}
        ).$promise.then(function(record){});
        $scope.tracking.checkFurthest(percent);
        if ($scope.completionPercent && $scope.onComplete && typeof $scope.completionPercent === 'number' && percent > $scope.completionPercent) {
          $scope.onComplete();
        }
      };

      function normalizeRect(rect) {
        var r = rect.slice(0);
        if (rect[0] > rect[2]) {
          r[0] = rect[2];
          r[2] = rect[0];
        }
        if (rect[1] > rect[3]) {
          r[1] = rect[3];
          r[3] = rect[1];
        }
        return r;
      };

      self.pdf = {
        link: '',
        scale: 1,
        canvas: null,
        annot: null,
        ctx: null,
        firstPage: false,
        lastPage: false,
        uniqueId: '',
        uniqueAnnotId: '',
        goPage: 1,
        totalPages: 0,
        viewSetting: false,
        returning: false,
        returnTo: null,
        setView: function() {
          this.viewSetting = true;
          checkReturn();
          setTimeout(async function() {
            if ($scope.link) {
              const PDFJS = await pdfjsImport.importModule();
              PDFJS.disableWorker = true;
              PDFJS.getDocument($scope.link).promise.then(function (pdfDoc_) {
                pdfDoc = pdfDoc_;
                self.navigation.pageNum = self.pdf.returnTo ? Math.round(self.pdf.returnTo / 100 * pdfDoc.numPages) : self.pdf.goPage ? self.pdf.goPage : 1;
                self.pdf.returnTo = null;

                self.pdf.totalPages = pdfDoc.numPages;
                self.navigation.totalPages = pdfDoc.numPages;
                // Initial/first page rendering
                var page = self.navigation.pageNum;
                self.navigation.renderPage(self.navigation.pageNum);
                self.pdf.viewSetting = false;
              });
            }
          }, 1);
        },
        onResize: function() {
          self.navigation.queueRenderPage(self.navigation.pageNum);
        },
        onOrientationChange: function(){
          self.navigation.queueRenderPage(self.navigation.pageNum);
        },
        changeScale: function(type) {
          var newScale = type === '-' ? this.scale - 0.25 : this.scale + 0.25;
          if (newScale <= 0.249 || newScale >= 10) {
            return;
          }
          this.scale = newScale;
          self.navigation.queueRenderPage(self.navigation.pageNum);
        }
      };

      self.onKeyUp = function(event) {
        if (event.keyCode == 37) {
          self.navigation.previous();
          $scope.$apply();
        }
        if(event.keyCode == 39) {
          self.navigation.next();
          $scope.$apply();
        }
      };

      // listen for key events for navigation
      window.addEventListener('keyup', self.onKeyUp, false);

      angular.element($window).on('resize', self.pdf.onResize);
      angular.element($window).on('orientationchange', self.pdf.onOrientationChange);

      $scope.$on('$destroy', function() {
        angular.element($window).off('resize', self.pdf.onResize);
        angular.element($window).off('orientationchange', self.pdf.onResize);
      });

      self.navigation = {
        pageNum: 1,
        totalPages: null,
        pageRendering: false,
        pageNumPending: null,
        fullscreen: false,
        renderPage: function(num) {
          if (!pdfDoc) {
            return;
          }
          this.pageRendering = true;
          num = parseInt(num);
          pdfDoc.getPage(num).then(function(page) {

            const viewers = document.querySelectorAll('.pdfjs__viewer__inner');
            // preview viewer will be the second viewer with the above class
            const viewer = $scope.preview ? viewers[1] : viewers[0];
            // in case of preview, add-file viewer will always show first, with clientWidth.  
            // Or preview will show with its own clientWidth
            const defaultWidth = viewers[0].clientWidth;
            const createViewport = function() {
              const falseViewport = page.getViewport({scale: 1});
              const width = viewer.clientWidth ? viewer.clientWidth : defaultWidth;
              const newRatio = ( width / falseViewport.width );
              return page.getViewport({scale: newRatio * self.upscaleBase * self.pdf.scale});
            };
            const viewport = createViewport();
            
            var createCanvas = function() {
              self.pdf.canvas.height = Math.floor(viewport.height);
              self.pdf.canvas.width = Math.floor(viewport.width);
              self.pdf.canvas.style.width = "100%";
              self.pdf.canvas.style.height = "100%";
              const containerId = $scope.preview ? '#preview-container' : '#container';
              var container = document.querySelector(containerId);
              container.style.height = 'auto';
              container.style.width = (Math.floor(viewport.width / self.upscaleBase) + 'px');
            };
            createCanvas();

            self.pdf.ctx.mozImageSmoothingEnabled = true;
            self.pdf.ctx.webkitImageSmoothingEnabled = true;
            self.pdf.ctx.msImageSmoothingEnabled = true;
            self.pdf.ctx.imageSmoothingEnabled = true;
            self.pdf.ctx.imageSmoothingQuality = 'high';
         
            var renderContext = {
              canvasContext: self.pdf.ctx,
              viewport: viewport
            };

            var renderTask = page.render(renderContext);

            $timeout(function(){self.navigation.showLoading = self.navigation.pageRendering ? true : false;}, 500);

            if (!self.pdf.returning && !self.pdf.viewSetting) {
              record(num);
            }

            if (self.pdf.returning && !self.pdf.viewSetting) {
              self.pdf.returning = false;
            }

            while (self.pdf.annot.firstChild) {
              self.pdf.annot.removeChild(self.pdf.annot.firstChild);
            }
            page.getAnnotations().then(function(annotationsData) {

              var viewer = document.querySelector('.pdfjs__viewer__inner');
              var scaledViewport ;
              var createScaledViewport = function(){
                var falseViewport = page.getViewport({scale: 1 * self.upscaleBase});
                scaledViewport = page.getViewport({scale: (viewer.clientWidth / falseViewport.width) * self.pdf.scale * self.upscaleBase}); 
              };
              createScaledViewport();

              var clonedViewport = scaledViewport.clone({
                  dontFlip: true
              });

              annotationsData.forEach(function(item, index) {
                if (item.subtype !== 'Link' || (!item.url && !item.dest)) {
                  return;
                }
                var element = item.url ? document.createElement('a') : document.createElement('span');
                if (item.url) {
                  element.href = item.url || '';
                  element.target = '_blank';
                }
                if (item.dest) {
                  element.addEventListener('click', function(evnt) {
                    pdfDoc.getPageIndex(item.dest[0])
                    .then(function(destIndex) {
                      self.navigation.pageNum = destIndex + 1;
                      $scope.$apply();
                    });
                  }, false);
                }

                var rect = normalizeRect([item.rect[0], page.view[3] - item.rect[1] + page.view[1], item.rect[2], page.view[3] - item.rect[3] + page.view[1]]);
                element.style.left = (rect[0]) + 'px';
                element.style.top = (rect[1]) + 'px';
                element.style.position = 'absolute';
                element.style.width = item.rect[2] - item.rect[0] + 'px';
                element.style.height = item.rect[3] - item.rect[1] + 'px';

                var transform = clonedViewport.transform;
                var transformStr = 'matrix(' + transform.join(',') + ')';
                CustomStyle.setProp('transform', element, transformStr);
                var transformOriginStr = -rect[0] + 'px ' + -rect[1] + 'px';
                CustomStyle.setProp('transformOrigin', element, transformOriginStr);

                self.pdf.annot.appendChild(element);
              });
            });

            // Wait for rendering to finish
            renderTask.promise.then(function () {
              self.navigation.pageRendering = false;
              $timeout(function(){self.navigation.showLoading = false;}, 0);
              if (self.navigation.pageNumPending !== null) {
                // New page rendering is pending
                self.navigation.renderPage(self.navigation.pageNumPending);
                self.navigation.pageNumPending = null;
              }
              $scope.$apply();
            });
          });
        },
        queueRenderPage: function (num) {
          if (this.pageRendering) {
            this.pageNumPending = num;
          } else {
            this.renderPage(num);
          }
        },
        previous: function() {
          if (this.pageNum <= 1) {
            return;
          }
          this.pageNum--;
        },
        next: function() {
          if (!pdfDoc || this.pageNum >= pdfDoc.numPages) {
            return;
          }
          this.pageNum++;
        },
        toggleFullscreen: function(){
          self.navigation.fullscreen = !self.navigation.fullscreen;
          var viewer = document.querySelector('.pdfjs__viewer__inner');
          var menu = document.querySelector('.pdfjs__menu');
          if (self.navigation.fullscreen) {
            var docheight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            viewer.style.maxHeight = docheight - menu.clientHeight + 'px';
          } else {
            viewer.style.maxHeight = '';
          }
          self.navigation.renderPage(self.navigation.pageNum);
        }
      };

      var delayStatus;
      $scope.$watch('pdfView.navigation.pageNum', function(newVal) {
        if (newVal && newVal > 0 && newVal <= self.navigation.totalPages) {
          if (typeof newVal === 'string') {
            delayStatus = setTimeout(pageDelay, 600);
            return;
          }
          delayStatus = null;
          pageDelay();
        }

        function pageDelay() {
          self.navigation.queueRenderPage(self.navigation.pageNum);
          self.pdf.lastPage = false;
          self.pdf.firstPage = false;
          if (self.navigation.pageNum === 1) {
            self.pdf.firstPage = true;
          }
          if (self.navigation.pageNum === self.navigation.totalPages) {
            self.pdf.lastPage = true;
          }
        }
      });

      self.fullReset = function() {
        self.navigation.pageNum = 1;
        self.navigation.pageRendering = false;
        self.navigation.pageNumPending = null;
        self.navigation.fullscreen = false;
        pdfDoc = null;
        self.pdf.scale = 1;
        self.pdf.firstPage = false;
        self.pdf.lastPage = false;
        self.pdf.totalPages = null;
      };

      self.pdf.uniqueId = '';
      self.pdf.uniqueAnnotId = '';
      var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 13; i++) {
        self.pdf.uniqueId += characters[Math.floor(Math.random() * characters.length)];
      }
      for (var i = 0; i < 13; i++) {
        self.pdf.uniqueAnnotId += characters[Math.floor(Math.random() * characters.length)];
      }

      $scope.$watch('link', function(newVal, oldVal) {
        if (newVal && typeof newVal === 'string' && newVal !== oldVal && newVal.slice(-3) === 'pdf') {
          self.fullReset();
          self.pdf.setView();
        }
      });

      if ($scope.link && typeof $scope.link === 'string' && $scope.link.slice(-3).toLowerCase() === 'pdf') {
        setTimeout(function() {
          self.pdf.canvas = document.getElementById(self.pdf.uniqueId);
          self.pdf.annot = document.getElementById(self.pdf.uniqueAnnotId);
          self.pdf.ctx = self.pdf.canvas.getContext('2d');
          self.pdf.setView();
        });
        return;
      }

      setTimeout(function() {
        self.pdf.canvas = document.getElementById(self.pdf.uniqueId);
        self.pdf.annot = document.getElementById(self.pdf.uniqueAnnotId);
        self.pdf.ctx = self.pdf.canvas.getContext('2d');
      });

    }],
    controllerAs: 'pdfView'
  };
}]);
